import { useState } from 'react';
import { DialogContent, FormControlLabel } from '@material-ui/core';

// @ts-expect-error - JS module without type declarations
import { CUSTOM_BUTTON_COLOR, CUSTOM_BUTTON_VARIANT } from 'src/components/CustomButton';
import { CustomCheckbox } from 'src/components/CustomCheckbox';
// @ts-expect-error - JS module without type declarations
import { CustomDialog } from 'src/components/CustomDialog';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { type GenerationTool, getToolTitle } from 'src/data/generationTool';
import type { Callback, VoidFunction } from 'src/lib/types';

import { useStyles } from './useStyles';

export interface SubmitResult {
  generationTool?: GenerationTool;
  dontShowAgain: boolean;
}

interface TemplateFoundPopupProps {
  open: boolean;
  generationTool: GenerationTool;
  onSubmit: Callback<SubmitResult>;
  onClose: VoidFunction;
  templateName?: string;
}

export const TemplateFoundPopup = ({
  open,
  generationTool,
  onSubmit,
  onClose,
  templateName,
}: TemplateFoundPopupProps) => {
  const styles = useStyles();

  const [dontShowAgain, setDontShowAgain] = useState<boolean>(false);
  const name = templateName || getToolTitle(generationTool);

  const handleSubmit = () => {
    onSubmit({ generationTool, dontShowAgain });
  };
  const handleCancel = () => {
    onSubmit({ dontShowAgain });
  };

  return (
    <CustomDialog
      className={styles.root}
      classes={{ buttonSubmit: styles.buttonSubmit }}
      open={open}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      onClose={onClose}
      onBack={onClose}
      title="Try a template?"
      submitLabel="Switch to template"
      cancelLabel="Stay with prompt"
      cancelProps={{ variant: CUSTOM_BUTTON_VARIANT.contained, color: CUSTOM_BUTTON_COLOR.silver }}
      data-testid="popupTemplateFound"
      dialogActionsSlot={
        <FormControlLabel
          control={
            <CustomCheckbox
              checked={dontShowAgain}
              onChange={() => setDontShowAgain((prev) => !prev)}
              color="primary"
            />
          }
          label={
            <CustomTypography variant={TYPOGRAPHY_VARIANT.regular14}>
              Don&apos;t show me this again
            </CustomTypography>
          }
        />
      }
      displayCloseIcon
    >
      <DialogContent className={styles.dialogContent}>
        <CustomTypography
          className={styles.description}
          variant={TYPOGRAPHY_VARIANT.paragraph16}
        >
          Your prompt looks like one of our templates: <b>{name}.</b>
        </CustomTypography>

        <CustomTypography
          variant={TYPOGRAPHY_VARIANT.paragraph16}
          className={styles.description}
        >
          Using a template can help structure your content and speed up generation.
        </CustomTypography>
      </DialogContent>
    </CustomDialog>
  );
};
